import React from 'react';
import { Select, Form } from 'antd';
import { Store, Tags, Settings2 } from 'lucide-react';
import { TraditionalStores, SectionCard } from '../../../common';

function CreateSegmentForm({ clients, channel, setChannel, storeType, onSelectType }) {
    const traditionalType = TraditionalStores.map((store) => ({
        label: store.label,
        value: store.value
    }));

    const modernClients = clients
        ?.filter((client) => client.channel === 'moderno')
        ?.map((client) => ({
            label: client.name,
            value: client._id
        }));

    return (
        <SectionCard
            icon={<Settings2 />}
            title="Configurar Segmentación de Productos"
            description="Selecciona el canal y el tipo de piso de venta para configurar su segmentación">
            <Form layout="vertical" requiredMark>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4">
                    <Form.Item label="Canal de la Segmentación" required className="!mb-0">
                        <Select
                            value={channel}
                            onChange={(e) => setChannel(e)}
                            placeholder="Selecciona el canal"
                            options={[
                                { value: 'moderno', label: 'Moderno' },
                                { value: 'tradicional', label: 'Tradicional' }
                            ]}
                            suffixIcon={<Store className="text-surface-400" />}
                        />
                    </Form.Item>

                    <Form.Item label="Tipo de Segmentación" required className="!mb-0 mt-4 md:mt-0">
                        <Select
                            showSearch
                            optionFilterProp="label"
                            value={storeType?.value}
                            onChange={(e) => onSelectType(e)}
                            placeholder="Selecciona el tipo"
                            options={channel === 'moderno' ? modernClients : traditionalType}
                            suffixIcon={<Tags className="text-surface-400" />}
                        />
                    </Form.Item>
                </div>
            </Form>
        </SectionCard>
    );
}

export default CreateSegmentForm;
